import React from 'react'

import { Link } from 'gatsby'

import LogoSVG from '@images/logo.svg'

interface Props {
	className?: string
}

const Logo = (props: Props) => {
	return (
		<div className={props.className}>
			<Link to="/">
				<LogoSVG />
			</Link>
		</div>
	)
}

export default Logo
